export default {
  //strain list
  strains: [],
  loading: false,
  total: 0,
  FilteredCount: 0,
  strain: null
}